import { CartTargetingDto } from "@intelligems/ig-types/dtos/cart-targeting";
import { CartTargetingExpressionPayload } from "@intelligems/ig-types/fe-only/shared-expression-targeting";
import { CartTargetingFe } from "@intelligems/ig-types/fe-only/cart-targeting";
import { postfixToExpressionList } from "@intelligems/ig-utils/expression";
import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { getCartTargeting } from "@src/store/slices/cartTargeting/index";

const EMPTY_EXPRESSION_LIST: CartTargetingExpressionPayload[] = [];

export const getCartTargetingExpressionList = (cartTargetingId: string) =>
  createSelector(getCartTargeting, (cartTargetingList) => {
    const cartTargeting = cartTargetingList.find(
      (ct) => ct.id === cartTargetingId
    );
    const expression = cartTargeting?.expression;

    if (expression) {
      return postfixToExpressionList(
        expression,
        "cartTargeting"
      ) as CartTargetingExpressionPayload[];
    }
    return EMPTY_EXPRESSION_LIST;
  });

export const getCartTargetingByIds = (cartTargetingIds: string[]) =>
  createSelector(getCartTargeting, (cartTargeting): CartTargetingFe[] => {
    const cartTargetingIdSet = new Set(cartTargetingIds);
    return cartTargeting.filter((targeting) =>
      cartTargetingIdSet.has(targeting.id)
    );
  });

const stripDisplayDataFromCartTargeting = (
  cartTargeting: CartTargetingFe[]
): CartTargetingDto[] => {
  return cartTargeting.map((ct) => ({
    ...ct,
    expression: ct.expression.map((expr) => {
      if (expr.query) {
        const { displayData, ...queryWithoutDisplayData } = expr.query as {
          displayData?: unknown;
        };

        const cleanQuery = Object.fromEntries(
          Object.entries(queryWithoutDisplayData).filter(
            ([_, v]) => v !== undefined
          )
        );

        return {
          ...expr,
          query: cleanQuery,
        };
      }
      return expr;
    }),
  })) as CartTargetingDto[];
};

export const getCartTargetingForPayload = createSelector(
  getCartTargeting,
  stripDisplayDataFromCartTargeting
);

export const getStoredCartTargetingForPayload = createSelector(
  (state: RootState) => state.cartTargeting.storedCartTargeting,
  stripDisplayDataFromCartTargeting
);
